const indexItems = [
  { icon: 'ri-star-line', title: '顶流明星', desc: '聚焦当红艺人的恋情、私生活与争议事件', count: '326条' },
  { icon: 'ri-tv-line', title: '综艺内幕', desc: '热门综艺节目的幕后争议与录制花絮爆料', count: '218条' },
  { icon: 'ri-live-line', title: '网红专区', desc: '直播圈、短视频平台的网红塌房与翻车实录', count: '195条' },
  { icon: 'ri-movie-line', title: '影视爆料', desc: '电影电视剧组的选角内定与拍摄现场争议', count: '147条' },
  { icon: 'ri-music-line', title: '音乐圈瓜', desc: '歌手、乐队、音乐节的八卦与争议事件汇总', count: '112条' },
  { icon: 'ri-building-line', title: '经纪公司', desc: '娱乐经纪公司的内部变动与合约纠纷曝光', count: '89条' },
  { icon: 'ri-global-line', title: '海外八卦', desc: '日韩欧美娱乐圈的热门爆料与争议事件速递', count: '64条' },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-4">
          分类索引
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          按类别快速浏览你感兴趣的黑料吃瓜内容
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {indexItems.map((item) => (
            <a
              key={item.title}
              href="#cards"
              className="flex items-start gap-4 p-4 md:p-5 bg-background-50 border border-background-200 rounded-lg hover:border-primary-200 hover:bg-background-100 transition-colors group cursor-pointer no-underline"
            >
              <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between mb-1">
                  <h3 className="text-sm font-semibold text-foreground-900">{item.title}</h3>
                  <span className="text-[11px] text-foreground-400 whitespace-nowrap">{item.count}</span>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}